enum IMAGE_TYPES {
    ORGANIZATION_IMAGE = 'organization',
    USER_IMAGE = 'user',
    TOKEN_IMAGE = 'token',
}

export { IMAGE_TYPES };
